/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface GetRegistryPrivileges200ResponseData
 */
export interface GetRegistryPrivileges200ResponseData {
  /**
   * Регистр добавлен в пользовательские регистры (только ТЗ)
   * @type {boolean}
   * @memberof GetRegistryPrivileges200ResponseData
   */
  appendedIntoUserRegistries?: boolean
  /**
   * Можно удалить из пользовательских регистров (только ТЗ)
   * @type {boolean}
   * @memberof GetRegistryPrivileges200ResponseData
   */
  canRemoveFromUserRegistries?: boolean
  /**
   * Пользователь — правообладатель/заявитель
   * @type {boolean}
   * @memberof GetRegistryPrivileges200ResponseData
   */
  userIsRegistryOwner: boolean
  /**
   * Можно добавить в пользовательские регистры (только ТЗ)
   * @type {boolean}
   * @memberof GetRegistryPrivileges200ResponseData
   */
  canAppendRegistryToUserRegistries?: boolean
}

/**
 * Check if a given object implements the GetRegistryPrivileges200ResponseData interface.
 */
export function instanceOfGetRegistryPrivileges200ResponseData(
  value: object
): value is GetRegistryPrivileges200ResponseData {
  if (
    !('userIsRegistryOwner' in value) ||
    value['userIsRegistryOwner'] === undefined
  )
    return false
  return true
}

export function GetRegistryPrivileges200ResponseDataFromJSON(
  json: any
): GetRegistryPrivileges200ResponseData {
  return GetRegistryPrivileges200ResponseDataFromJSONTyped(json, false)
}

export function GetRegistryPrivileges200ResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetRegistryPrivileges200ResponseData {
  if (json == null) {
    return json
  }
  return {
    appendedIntoUserRegistries:
      json['appendedIntoUserRegistries'] == null
        ? undefined
        : json['appendedIntoUserRegistries'],
    canRemoveFromUserRegistries:
      json['canRemoveFromUserRegistries'] == null
        ? undefined
        : json['canRemoveFromUserRegistries'],
    userIsRegistryOwner: json['userIsRegistryOwner'],
    canAppendRegistryToUserRegistries:
      json['canAppendRegistryToUserRegistries'] == null
        ? undefined
        : json['canAppendRegistryToUserRegistries'],
  }
}

export function GetRegistryPrivileges200ResponseDataToJSON(
  value?: GetRegistryPrivileges200ResponseData | null
): any {
  if (value == null) {
    return value
  }
  return {
    appendedIntoUserRegistries: value['appendedIntoUserRegistries'],
    canRemoveFromUserRegistries: value['canRemoveFromUserRegistries'],
    userIsRegistryOwner: value['userIsRegistryOwner'],
    canAppendRegistryToUserRegistries:
      value['canAppendRegistryToUserRegistries'],
  }
}
